<template>
  <div class="security-password-input">
    <label :for="label" class="security-password-input__label"></label>
    <div class="security-password-input__wrapper">
      <input
        :type="inputType"
        class="security-password-input__field"
        :class="{
          'security-password-input__field--error': showError === true,
        }"
        v-model="pass"
        @blur="$emit('validate', placeHolder)"
        :placeholder="placeHolder"
        :disabled="disabled"
        required
      />
      <button 
        type="button" 
        class="security-password-input__toggle"
        @click="showPassword" 
        :disabled="!password"
      >
        <svg v-if="inputType === 'password'" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 2L22 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <p v-if="showError" class="security-password-input__error">
      {{ errorMsg }}
    </p>
  </div>
</template>

<script>
export default {
  name: "SecurityPasswordInput",

  emits: ["set", "validate"],

  props: {
    placeHolder: { type: String, default: () => "", required: true },
    label: { type: String, default: () => "", required: true },
    password: { type: String, default: () => "", required: true },
    error: { type: Object, default: () => {}, required: true },
    inputName: { type: String, default: () => "", required: true },
    disabled: { type: Boolean, default: () => false, required: true },
  },

  data() {
    return {
      inputType: "password",
      showError: false,
      errorMsg: "",
    };
  },

  computed: {
    pass:{
      get(){
        return this.password
      },
      set(value){
        this.$emit("set", value)
      },
    }
  },

  methods: {
    checkError() {
      switch (this.error.$property) {
        case "password":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;
        case "confirmPassword":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;

        default:
          this.showError = false;
          this.errorMsg = "";
          break;
      }
    },

    showPassword() {
      if (this.inputType === "password") {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    },
  },

  watch: {
    error(newValue, oldValue) {
      deep: true;
      immediate: true;
      if (newValue !== oldValue) {
        this.checkError();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.security-password-input {
  display: flex;
  flex-direction: column;

  &__label {
    display: none;
  }

  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__field {
    width: 100%;
    padding: 14px 48px 14px 16px;
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #0F172A;
    transition: all 0.2s ease;

    &::placeholder {
      color: #94A3B8;
    }

    &:focus {
      outline: none;
      border-color: #4D84FF;
      background: white;
      box-shadow: 0 0 0 3px rgba(77, 132, 255, 0.1);
    }

    &:disabled {
      background: #F1F5F9;
      cursor: not-allowed;
    }

    &--error {
      border-color: #EF4444;

      &:focus {
        border-color: #EF4444;
        box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
      }
    }
  }

  &__toggle {
    position: absolute;
    right: 14px;
    padding: 4px;
    background: transparent;
    border: none;
    color: #64748B;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;

    &:hover {
      color: #0F172A;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &__error {
    margin: 6px 0 0 0;
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: #EF4444;
  }
}
</style>
